export default "__VITE_ASSET__ecB2c2Qf__"